import React from 'react'
import { ReactDatePickerProps } from 'react-datepicker'

import FormInput from '../forms/FormInput'
import RawDatePicker from './RawDatePicker'

type Props = {
  /** Label to show on the input. */
  label?: string
  /** HTML for attribute */
  htmlFor: string
  /** Current value */
  value?: string
  /** Externally defined className for the input wrapper. */
  wrapperClassName?: string
  /** Externally defined className for the date picker. */
  datePickerClassName?: string
  /** Form field description. */
  description?: string
  /** True if the box is in invalid state. */
  isInvalid?: boolean
  /** True if a value for the field is required */
  isRequired?: boolean
}

/** DatePicker to be used within the scope of a form. */
const DatePicker = <
  CustomModifierNames extends string = never,
  WithRange extends boolean | undefined = undefined,
>({
  htmlFor,
  description,
  isRequired,
  label,
  wrapperClassName,
  datePickerClassName,
  ...other
}: ReactDatePickerProps<CustomModifierNames, WithRange> & Props) => {
  return (
    <FormInput
      label={label}
      description={description}
      htmlFor={htmlFor}
      isRequired={isRequired}
      className={wrapperClassName}
    >
      <RawDatePicker
        htmlFor={htmlFor}
        className={datePickerClassName}
        {...other}
      />
    </FormInput>
  )
}

export default DatePicker
